import {createStore} from "vuex";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    state: {
        accessToken: null,
        refreshToken: null,
        role: null,
        user: {},
        collapsed: false,
        headerTitle: "Bosh sahifa",
        brItems: []
    },
    mutations: {
        authenticate(state, tokenResponse) {
            let {access_token, refresh_token, role} = tokenResponse;
            state.accessToken = access_token;
            state.refreshToken = refresh_token;
            state.role = role;
        },
        setRole(state, role) {
            state.role = role;
        },
        signOut(state) {
            state.accessToken = null;
            state.refreshToken = null;
            state.role = null;
            state.user = {}
        },
        userData(state, userData) {
            state.user = userData;
        },
        updateCollapsed(state, newCollapse) {
            state.collapsed = newCollapse
        },
        updateHeaderTitle(state, title) {
            state.headerTitle = title
        },
        updateBrItems(state, item) {
            state.brItems.push(item)
        },
        sliceBrItems(state, index) {
            state.brItems.splice(index)
        },
        clearBrItems(state) {
            state.brItems = []
        }
    },
    actions: {},
    plugins: [
        createPersistedState({
            key: "openBudget",
            paths: ["accessToken",
                "refreshToken",
                "collapsed",
                "headerTitle",
                "user",
                "role",
                'brItems'
            ],
        }),
    ],
});

export default store;
